import React from 'react'
import {Message} from 'semantic-ui-react'

export const GraphQLError = ({ error }) => {
  return (
    <Message>
      {error.graphQLErrors.map((err, i) => (
        <p key={`error-${i}`}>{err.message}</p>
      ))}
    </Message>
  )
}



// WEBPACK FOOTER //
// ./src/components/GraphQLError.js